import { CustomGeojson3d, FlightLayerFacade } from '@fe/flight-layer';
import React from 'react';
import { DrawingObjectsLayer } from '../../../components/drawing-object/drawing-object-layer';
import { RouteAnalyzerLayer } from '../../../components/route-analyzer/layers/route-analyzer-layer';
import { AirportMonitorStatusLayer } from '../../../layers/airport-monitor-status-layer';
import { DiversionStatusLayer } from '../../../layers/diversion-status-layer';
import { NavDataPlugin } from '../../../plugins/nav-data-plugin';
import { FeWeatherPlugin } from '../../../services/fe-weather-plugin';
import { MapInteractionService } from '../../../services/map-interaction-service';
import { FeMap } from '../../components/map/fe-map';
import { useAppSelector } from '../../hooks/store-hooks';
import { WorkspaceManagementContext } from './workspace-management-context';

export interface WorkspaceItemContextObject {
    readonly id: number;
    readonly weatherService: FeWeatherPlugin;
    readonly interactionService: MapInteractionService;
    readonly routeAnalyzerLayer: RouteAnalyzerLayer;
    readonly drawingObjectsLayer: DrawingObjectsLayer;
    readonly navDataPlugin: NavDataPlugin;
    readonly customGeojsonPlugin: CustomGeojson3d;
    readonly flightLayerFacade: FlightLayerFacade;
    readonly airportMonitorStatusLayer: AirportMonitorStatusLayer;
    readonly diversionLayer: DiversionStatusLayer;
    readonly map: FeMap | null;
}

export const WorkspaceItemContext = React.createContext<WorkspaceItemContextObject>({
    id: 0,
    weatherService: null!,
    interactionService: null!,
    routeAnalyzerLayer: null!,
    drawingObjectsLayer: null!,
    navDataPlugin: null!,
    customGeojsonPlugin: null!,
    flightLayerFacade: null!,
    airportMonitorStatusLayer: null!,
    diversionLayer: null!,
    map: null
});

export default WorkspaceItemContext; // TODO: figure out why vscode doesn't want to auto-import without default export

export function useWorkspaceItemContext() {
    return React.useContext(WorkspaceItemContext);
}

export function useFocusedWorkspaceItemContext() {
    const selectedWorkspaceIndex = useAppSelector((x) => x.workspace.selectedId);
    const context = React.useContext(WorkspaceManagementContext);
    return context.items[selectedWorkspaceIndex];
}
